
<template>
  <div class="businessInformation">
    <div class="main" v-if="contractType">
      <div class="top-search">
        <div class="search-item">
          公司名称：
          <div>
            <el-autocomplete
              v-model="merchantsName"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              @clear="clearSelect"
              clearable
              placeholder="单行输入"
            ></el-autocomplete>
          </div>
        </div>
        <div class="search-item-ele">
          创建时间：
          <el-date-picker
            v-model="merchantsTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
        <div class="search-item" style="margin-top: -5px;">
          <el-button type="primary" @click="merchantsSearch" size="small">搜索</el-button>
        </div>
        <div class="search-item" style="margin-top: -5px;">
          <el-button type="primary" @click="merchantsReset" plain size="small">重置</el-button>
        </div>
      </div>
      <div class="top-search">
        <div class="search-item">
          <el-button type="danger" @click="merchantsIncrease()" size="small">增加商户</el-button>
        </div>
        <!-- <div class="search-item"><el-button type="primary">下载列表</el-button></div> -->
      </div>
      <div class="down-list">
        <el-table :data="tableData" border :header-cell-style="{background:'rgb(250, 250, 250)'}" style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="公司名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="id" label="公司ID" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="taxTypeName" label="纳税人类型" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="contactName" label="联系人姓名" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="contactMobile" label="联系人手机号码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="contactEmail" label="联系人邮箱" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="审核" v-if="scope.row.status == '00'">
                      <el-button
                        @click="auditOpen(scope.row.id)"
                        type="primary"
                        size="mini"
                        plain
                      >&emsp;审核&emsp;</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item command="编辑">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="editorOpen(scope.row)"
                        plain
                      >&emsp;编辑&emsp;</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item command="签约" v-if="scope.row.status == '10'">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="signingOpen(scope.row,3)"
                        plain
                      >&emsp;签约&emsp;</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item command="查看签约" v-if="scope.row.status == '90'">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="signingOpen(scope.row,4)"
                        plain
                      >查看签约</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="bottom-pag">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="currentChange">
            </el-pagination>
      </div>-->
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
    <div class="main contractType" v-if="!contractType">
      <div class="title">
        <div class="fanhui" @click="returnList()">
          <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="qianyue">客户签约</div>
      </div>
      <div class="box1" v-if="contractCode == 4">
        <div class="item">
          <span>客户名称：{{tableDataObj.name}}</span>
          <span>商户ID：{{tableDataObj.id}}</span>
          <span>签约主体：{{signingObj.nameA}}</span>
        </div>
        <div class="item">
          <span>合同编码：{{signingObj.contractNo}}</span>
          <span>签约开始时间：{{signingObj.beginDate}}</span>
          <span>签约失效时间：{{signingObj.endDate}}</span>
          <span>服务费：{{signingObj.serviceRate}}%</span>
        </div>
      </div>
      <div class="box1" style="padding: 20px" v-if="contractCode == 3">
        <div class="item" style="padding-left: 50px">
          <span>客户名称：{{tableDataObj.name}}</span>
          <span>商户ID：{{tableDataObj.id}}</span>
        </div>
        <div class="item list">
          <div class="search-item">
            <span>签约主体：</span>
            <div>
              <el-input placeholder="请输入" v-model="signingObj.nameA" clearable></el-input>
            </div>
          </div>
          <div class="search-item">
            <span>合同编码：</span>
            <div>
              <el-input placeholder="请输入" v-model="signingObj.contractNo" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="item list">
          <div class="search-item">
            <span>签约开始时间：</span>
            <div>
              <el-date-picker
                v-model="signingObj.beginDate"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <!-- <el-input placeholder="请输入" v-model="signingObj.beginDate" clearable></el-input> -->
            </div>
          </div>
          <div class="search-item">
            <span>签约失效时间：</span>
            <div>
              <el-date-picker
                v-model="signingObj.endDate"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <!-- <el-input placeholder="请输入" v-model="signingObj.endDate" clearable></el-input> -->
            </div>
          </div>
          <div class="search-item">
            <span>服务费（%）：</span>
            <div>
              <el-input placeholder="请输入" v-model="signingObj.serviceRate" clearable></el-input>
            </div>
          </div>
        </div>
      </div>

      <div
        class="remind"
        v-if="contractCode == 3"
      >系统默认设置：专户专用，即该公司绑定的个体工商户仅支持本商户业务开展使用。如若允许其他商户使用，请开通业务合作摄制，并设置关联商户</div>
      <div v-if="contractCode == 3" style="width:100%;margin-top:20px;">
        <el-button type="primary" @click="signingConfirm">&emsp;确认&emsp;</el-button>
      </div>
      <!-- <div class="box2">
          <span class="title">业务合作</span>
          <div class="text">
            <el-switch
              v-model="value1"
              inactive-text="业务合作">
            </el-switch>
          </div>
          <div class="text" v-if="contractCode == 4">关联商户：汉唐信通科技有限公司</div>
          <div class="text" v-if="contractCode == 3">
            关联商户：
            <el-select v-model="merchantsValue" multiple placeholder="请选择">
              <el-option
                v-for="item in merchantsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
      </div>-->
    </div>
    <el-dialog
      title="添加商户"
      width="730px"
      :visible.sync="dialogVisible1"
      :before-close="handleClose"
    >
      <div style="width:710px;margin: 0 auto;">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <div class="dialog-title">基本信息</div>
          <el-form-item label="企业名称：" prop="name">
            <div class="dialog-input">
              <el-input v-model="ruleForm.name"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="纳税人类型：" prop="taxType" style="text-align: left;">
            <el-radio-group v-model="ruleForm.taxType">
              <el-radio label="0">一般纳税人</el-radio>
              <el-radio label="1">小规模纳税人</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="联系人姓名：" prop="contactName">
            <div class="dialog-input">
              <el-input v-model="ruleForm.contactName"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="联系人手机：" prop="contactMobile">
            <div class="dialog-input">
              <el-input v-model="ruleForm.contactMobile"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="联系人邮箱：" prop="contactEmail">
            <div class="dialog-input">
              <el-input v-model="ruleForm.contactEmail"></el-input>
            </div>
          </el-form-item>
          <div v-if="dialogType == 1">
            <div class="dialog-title">开票信息</div>
            <el-form-item label="纳税人识别号：" prop="taxNo">
              <div class="dialog-input">
                <el-input v-model="ruleForm.taxNo"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="地址：" prop="invoiceAddr">
              <div class="dialog-input">
                <el-input v-model="ruleForm.invoiceAddr"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="开户名称：" prop="accountName">
              <div class="dialog-input">
                <el-input v-model="ruleForm.accountName"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="对公账户：" prop="accountPublic">
              <div class="dialog-input">
                <el-input v-model="ruleForm.accountPublic"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="电话：" prop="invoiceMobile">
              <div class="dialog-input">
                <el-input v-model="ruleForm.invoiceMobile"></el-input>
              </div>
            </el-form-item>
            <div class="dialog-title">邮寄地址</div>
            <el-form-item label="地址：" prop="mailAddr">
              <div class="dialog-input">
                <el-input v-model="ruleForm.mailAddr"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="收件人：" prop="mailTo">
              <div class="dialog-input">
                <el-input v-model="ruleForm.mailTo"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="联系电话：" prop="mailMobile">
              <div class="dialog-input">
                <el-input v-model="ruleForm.mailMobile"></el-input>
              </div>
            </el-form-item>
          </div>
          <div class="dialog-title">客户支持</div>
          <el-form-item label="客户经理：" prop="ownerName">
            <div class="dialog-input">
              <el-select v-model="ruleForm.ownerName" style="width:100%" placeholder="请选择">
                <el-option
                  v-for="item in ownerOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="手机号码：" prop="ownerMobile">
            <div class="dialog-input">
              <el-input v-model="ruleForm.ownerMobile"></el-input>
            </div>
          </el-form-item>
          <div>
            <el-button @click="cancelForm">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="审核" :visible.sync="dialogVisible2" width="30%" :before-close="handleClose">
      <div class="dialog2-title">请确定该商户的系统登录账号：</div>
      <el-input v-model="ucName" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="auditDown">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      //总条数
      total: null,
      pageSize: 10,
      // 登录账号
      ucName: "",
      ucId: "",
      // 控制签约页
      contractType: true,
      contractCode: null,
      tableDataObj: {},
      signingObj: {
        merchantId: "",
        nameA: "",
        contractNo: "",
        beginDate: "",
        endDate: "",
        serviceRate: ""
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      merchantsTime: "",
      merchantsName: "",
      CompanyOptions: [],
      merchantsOptions: [],
      merchantsValue: [],
      // 控制两个dialog
      dialogVisible1: false,
      dialogVisible2: false,
      ruleForm: {
        id: 0,
        name: "",
        taxType: "",
        contactName: "",
        contactMobile: "",
        contactEmail: "",
        taxNo: "",
        invoiceAddr: "",
        invoiceMobile: "",
        accountName: "",
        accountPublic: "",
        mailAddr: "",
        mailTo: "",
        mailMobile: "",
        ownerName: "",
        ownerMobile: ""
      },
      rules: {
        name: [
          { required: true, message: "请按要求填入信息", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "blur"
          }
        ],
        contactMobile: [
          {
            required: true,
            pattern: /^1[34578]\d{9}$/,
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        contactEmail: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        contactName: [
          { required: true, message: "请输入联系人姓名", trigger: "change" }
        ],
        taxNo: [
          { required: true, message: "请输入纳税人识别号", trigger: "change" }
        ],
        invoiceAddr: [
          { required: true, message: "请输入地址", trigger: "change" }
        ],
        invoiceMobile: [
          {
            required: true,
            pattern: /^1[34578]\d{9}$/,
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        accountName: [
          { required: true, message: "请输入开户名称", trigger: "change" }
        ],
        accountPublic: [
          { required: true, message: "请输入对公账户", trigger: "change" }
        ],
        mailAddr: [
          { required: true, message: "请输入邮寄地址", trigger: "change" }
        ],
        mailTo: [
          { required: true, message: "请输入收件人", trigger: "change" }
        ],
        mailMobile: [
          {
            required: true,
            pattern: /^1[34578]\d{9}$/,
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        ownerName: [
          { required: true, message: "请输入客户经理", trigger: "change" }
        ],
        ownerMobile: [
          {
            required: true,
            pattern: /^1[34578]\d{9}$/,
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ]
      },
      ownerOptions: [
        {
          value: 1,
          label: "杨庆菊"
        }
      ],
      input: "",
      tableData: [],
      merchantsid: "",
      dialogType: 1
    };
  },
  mounted() {
    this.CompanyOptions =
      JSON.parse(localStorage.getItem("merchantsList")) || [];
    this.allListPost();
  },
  methods: {
    clearSelect() {
      this.merchantsid = "";
      this.allListPost();
    },
    handleSelect(item) {
      console.log(item);
      this.merchantsid = item.id;
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    querySearch(queryString, cb) {
      var CompanyOptions = this.CompanyOptions;
      var results = queryString
        ? CompanyOptions.filter(this.createFilter(queryString))
        : CompanyOptions;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    auditOpen(id) {
      // console.log(id)
      this.ucId = id;
      this.ucName = "";
      this.dialogVisible2 = true;
    },
    auditDown() {
      if (this.ucnameName != "") {
        this.dialogVisible2 = false;
        post(api.merchantsAudit, {
          id: this.ucId,
          ucname: this.ucName
        }).then(
          d => {
            console.log(d);
            if (d.status === 0) {
              this.$message({
                message: "成功提交审核",
                type: "success"
              });
              this.allListPost();
            }
          },
          err => {
            //error callback
          }
        );
      } else {
        this.$message({
          message: "请按要求填写",
          type: "warning"
        });
      }
    },
    // 查看签约/签约
    signingDown() {},
    // 返回列表
    returnList() {
      this.contractType = true;
      this.signingObj = {
        merchantId: "",
        nameA: "",
        contractNo: "",
        beginDate: "",
        endDate: "",
        serviceRate: ""
      };
    },
    signingOpen(obj, key) {
      console.log(obj);
      if (key == 4) {
        post(api.showSign, {
          merchantId: obj.id
        }).then(
          d => {
            console.log(d.status);
            if (d.status === 0) {
              console.log(d, "!!!!!!!!!!!!");
              this.signingObj = d.data;
            }
          },
          err => {
            //error callback
          }
        );
      }
      this.tableDataObj = obj;
      this.contractType = false;
      this.contractCode = key;
    },
    // 确认签约
    signingConfirm() {
      this.signingObj.merchantId = this.tableDataObj.id;
      for (var i in this.signingObj) {
        console.log(i, ":", this.signingObj[i]);
        if (this.signingObj[i] == "") {
          this.$message({
            message: "警告，字段不能为空，请按需求填写",
            type: "warning"
          });
          return;
        }
      }
      post(api.merchantSign, this.signingObj).then(
        d => {
          console.log(d.status);
          if (d.status === 0) {
            this.$message({
              showClose: true,
              message: "签约成功",
              type: "success"
            });
            this.signingObj = {
              merchantId: "",
              nameA: "",
              contractNo: "",
              beginDate: "",
              endDate: "",
              serviceRate: ""
            };
            this.contractType = true;
            this.allListPost();
          }
        },
        err => {
          //error callback
        }
      );
    },
    // 编辑
    editorOpen(obj) {
      var nobj = {};
      if (obj) {
        for (var idx in obj) {
          nobj[idx] = obj[idx];
        }
      }
      console.log(obj);
      this.ruleForm = nobj;
      this.ruleForm.taxType = this.ruleForm.taxType.toString();
      this.dialogType = 2;
      this.dialogVisible1 = true;
    },
    // currentChange(size) {
    //   console.log(size)
    //   this.allListPost(size)
    // },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条aaaaa`);
      this.pageSize = val;
      this.allListPost();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
      this.allListPost(val);
    },
    // 重置
    merchantsReset() {
      this.merchantsName = "";
      this.merchantsid = "";
      this.merchantsTime = ["", ""];
      this.allListPost();
    },
    merchantsSearch() {
      if (this.merchantsTime.length == 0) {
        console.log("空的");
        this.merchantsTime = ["", ""];
      }
      console.log(this.merchantsTime);
      this.allListPost();
    },
    allListPost(size) {
       const loading = this.$loading({
        lock: true,
        spinner: 'loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      post(api.merchantsInfoPage, {
        currentPage: size || 1,
        pageSize: this.pageSize,
        merchantId: this.merchantsid,
        createdBegin: this.merchantsTime[0] || "",
        createdEnd: this.merchantsTime[1] || ""
      }).then(
        d => {
          console.log(d.status);
           loading.close();
          if (d.status === 0) {
            console.log(d, "??????????????");
            this.total = d.data.count;
            this.tableData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    // 增加商户
    merchantsIncrease() {
      this.dialogVisible1 = true;
      this.dialogType = 1;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          this.$refs.ruleForm.resetFields();
          console.log(this.ruleForm);
          done();
        })
        .catch(_ => {});
    },
    cancelForm() {
      this.dialogVisible1 = false;
      this.$refs.ruleForm.resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogType == 1) {
            post(api.merchantsAdd, this.ruleForm).then(
              d => {
                console.log(d.status);
                if (d.status === 0) {
                  this.dialogVisible1 = false;
                  this.$message({
                    message: "新增成功",
                    type: "success"
                  });
                  this.$refs[formName].resetFields();
                  this.allListPost();
                }
              },
              err => {
                //error callback
              }
            );
          } else {
            post(api.merchantsUpd, this.ruleForm).then(
              d => {
                if (d.status === 0) {
                  this.dialogVisible1 = false;
                  this.$message({
                    message: "修改成功",
                    type: "success"
                  });
                  this.$refs[formName].resetFields();
                  this.allListPost();
                }
              },
              err => {
                //error callback
              }
            );
            cosnole.log("编辑");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.businessInformation {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 17px 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      height: 52px;
      line-height: 52px;
      margin-bottom: 10px;
      .search-item-ele {
        float: left;
        margin-right: 20px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .search-item {
        float: left;
        margin-right: 20px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        div {
          display: inline-block;
          width: 250px;
        }
      }
    }
    .down-list {
      width: 100%;
    }
    .bottom-pag {
      width: 100%;
      text-align: center;
      margin-top: 20px;
    }
  }
  .contractType {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .box1 {
      width: 100%;
      min-height: 127px;
      overflow: hidden;
      background: rgba(250, 250, 250, 0.78);
      border-radius: 6px;
      padding: 30px 40px;
      box-sizing: border-box;
      .list {
        margin-top: 17px;
      }
      .item {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        line-height: 32px;
        overflow: hidden;
        span {
          display: inline-block;
          width: 295px;
        }
        .search-item {
          float: left;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          span {
            display: inline-block;
            width: 121px;
            text-align: right;
          }
          div {
            display: inline-block;
            width: 233px;
          }
        }
      }
    }
    .box2 {
      margin-top: 20px;
      width: 100%;
      height: 213px;
      background: rgba(251, 251, 251, 0.78);
      border-radius: 6px;
      padding: 30px 40px;
      box-sizing: border-box;
      text-align: left;
      .title {
        display: block;
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      .text {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
      }
    }
    .remind {
      width: 100%;
      height: 61px;
      line-height: 61px;
      padding-left: 35px;
      margin-top: 20px;
      box-sizing: border-box;
      background: rgba(255, 250, 227, 1);
      border: 1px solid rgba(255, 166, 61, 1);
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: left;
    }
  }
  .dialog-title {
    width: 100%;
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 60px;
  }
  .dialog-input {
    width: 541px;
    height: 40px;
  }
  .dialog2-title {
    width: 100%;
    text-align: left;
    line-height: 60px;
    font-size: 14px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/merchants/client/businessInformation.vue